import React, { useState, useEffect } from 'react'
import './profile-content.scss'
import Menu from '../../atoms/menu/menu'
import ModalLogin from '../modal-login/modal-login'
import userSessionStorage from '../../../utils/userSessionStorage'
import { AmbassadorService } from '../../../services/ambassador'
import { concourseId, getAmbassadorType } from '../../../constants/activity-constants'
import { graphql, navigate, useStaticQuery } from 'gatsby'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

import reto1 from '../../../assets/images/challenges/retoOne.svg'
import reto2 from '../../../assets/images/challenges/retoThree.svg'
import reto3 from '../../../assets/images/challenges/retoThree.svg'
import profileImg from '../../../assets/images/profile/foto-fake.jpg'
import Button from '../../atoms/button/button'

const ProfileContent = () => {


  const [isModalOpen, setIsModalOpen] = useState(false)
  const session = new userSessionStorage()

  const [name, setName] = useState('')
  const [isAmbassador, setIsAmbassador] = useState(false)
  const [ambassadorType, setAmbassadorType] = useState(false)
  const [challengesCompleted, setChallengesCompleted] = useState([])

  const [isSendUrlActualChallenge, setIsSendUrlActualChallenge] = useState(false)

  const [sendUrl, setSendUrl] = useState(false)

  const [url, setUrl] = useState('')
  const actualChallenge = 'urlReto1'

  const validateParticipation = async () => {
    try {
      const res = await AmbassadorService.getParticipation(concourseId)
      if (res.status === 200) {
        // is ambassodor
        // console.log(res)
        let id = res.data.ambassador.productId
        setAmbassadorType(getAmbassadorType(id))
        setIsAmbassador(true)
        setChallengesCompleted(res.data.ambassadorParticipate)

      } else {
        navigate('/')
      }
    } catch (e) {
      console.error(e)
    }
  }


  useEffect(() => {
    // validate is logged
    const tokenInfo = session.getToken()
    if (tokenInfo) {
      const userInfo = session.getUserInfo()
      setName(userInfo.name + ' ' + userInfo.lastName)
      if (userInfo) {
        setIsModalOpen(false)
        //Validate is ambassor
        validateParticipation()


      } else {
        setIsModalOpen(true)
      }
    } else {
      setIsModalOpen(true)

    }
  }, [])

  useEffect(() => {
    let isSend = challengesCompleted.some(item => {
      return item.type === actualChallenge
    })
    setIsSendUrlActualChallenge(isSend)
    setChallenges(challenges)

  }, [challengesCompleted])


  const [challenges, setChallenges] = useState(
    [
      {
        txt: 'Reto 1',
        img: reto1,
      },
      {
        txt: 'Reto 2',
        img: reto2,
      },
      {
        txt: 'Reto 3',
        img: reto3,
      },
    ],
  )

  const onSubmitUrl = async () => {
    if (url.length < 7) {
      return
    }
    console.log(url)
    setSendUrl(true)

    let payload = {
      type: actualChallenge,
      url: url,
    }

    try {
      const res = await AmbassadorService.saveUrlChallenge(concourseId, payload)
      if (res.status === 200) {
        setSendUrl(false)
        setIsSendUrlActualChallenge(true)
      } else {
        setSendUrl(false)

      }
    } catch (e) {
      console.error(e)
      setSendUrl(false)

    }
  }


  return (
    <>
      <Menu />
      {isAmbassador ? (
        <section className='f-profile-content'>
          <div className='f-profile-content__wrapper'>
            <div className='f-profile-content__container-profile'>
              <div className='f-profile-content__image'>
                <div className='f-profile-content__image__img'>
                  <img src={profileImg} />
                </div>

              </div>
              <div className='f-profile-content__info'>
                <div className='f-profile-content__info__ambassador'>
                  <h2 className='f-profile-content__info__ambassador__name'>{name}</h2>
                  {ambassadorType && (
                    <div className='f-profile-content__info__ambassador__product'>
                      <div className='f-profile-content__info__ambassador__product__img'>

                        <img src={ambassadorType.img} alt='Producto Embajadora' />
                      </div>
                      <div className='f-profile-content__info__ambassador__product__name'>
                        <p>EMBAJADORA NOSOTRAS</p>
                        <b>{ambassadorType.text}</b>
                      </div>

                    </div>
                  )
                  }
                </div>
                <div className='f-profile-content__info__challenges'>
                  <h2 className='f-profile-content__info__challenges__title'>Retos en los que has participado</h2>
                  <div className='f-profile-content__info__challenges__list'>
                    {challenges.map((item, index) => {
                      let active = challengesCompleted.some(item => {
                        return item.type === `urlReto${index + 1}`
                      })
                      return (
                        <div className={`f-profile-content__info__challenges__list__item ${!active ? 'block' : ''}`}>
                          <img src={item.img} />
                          <p>{item.txt}</p>
                        </div>
                      )
                    })}


                  </div>
                </div>
              </div>
            </div>
            {!isSendUrlActualChallenge && (
              <div className='f-profile-content__url'>
                <h2 className='f-profile-content__url__title'>INGRESA LA <b>URL DE TUS PUBLICACIONES</b></h2>
                <div className='f-profile-content__url__search'>
                  <input
                    type='text'
                    autoComplete='off'
                    name='filter-name'
                    value={url}
                    onChange={(e) => setUrl(e.target.value)}

                  />
                  <Button
                    color='dark-purple'
                    disabled={sendUrl}
                    onClick={() => onSubmitUrl()}
                  >
                    Ingresar
                  </Button>

                </div>
              </div>
            )}

          </div>
        </section>
      ) : (
        <div className='f-page-loading'>
          <div className='lds-grid'>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}


      {isModalOpen && (
        <ModalLogin
          onClose={() => {
            setIsModalOpen(false)
          }}
          onlyLogin={true}
        />
      )}

    </>
  )
}

export default ProfileContent
